import { BaseTabs } from '@components';
import { useLingui } from '@lingui/react/macro';
import { SharedPageWrapper } from '@routes/___shared___/styled.tsx';
import { PageHeader } from '@routes/profile-bar/___pages___/my-profile/styled.tsx';
import ProfileHeader from '@routes/sidebar/___shared___/components/profile-header';
import ConsentCenterList from '@routes/sidebar/settings/ui/consent-center-tab';
import UserPreferences from '@routes/sidebar/settings/ui/user-preferences-tab';
import type { TabsProps } from 'antd';

// needs to be a hook to use useLingui() safely
const useTabs = (): TabsProps['items'] => {
    const { t } = useLingui();

    return [
        {
            key: 'user preferences',
            label: t`User preferences`,
            children: <UserPreferences />,
        },
        {
            key: 'consent center',
            label: t`Consent center`,
            children: <ConsentCenterList />,
        },
    ];
};

const UserSettings = () => {
    const { t } = useLingui();
    const tabs = useTabs();

    return (
        <div>
            <SharedPageWrapper>
                <PageHeader>{t`Account Settings`}</PageHeader>
                <ProfileHeader />
                <BaseTabs defaultActiveKey="user preferences" items={tabs} />
            </SharedPageWrapper>
        </div>
    );
};

export default UserSettings;
